<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item md-size-50 my-2">
        {{ $t("communication_log.col_staff_contact") }}:
        <b>{{ communicationLogDetail.username }}</b>
      </div>
      <div class="md-layout-item md-size-50 my-2">
        {{ $t("communication_log.col_date_contact") }}:
        <b>{{ communicationLogDetail.date_of_contact }}</b>
      </div>
      <div class="md-layout-item md-size-50 my-2">
        {{ $t("communication_log.col_method") }}:
        <b>{{ communicationLogDetail.method }}</b>
      </div>
      <div class="md-layout-item md-size-50 my-2">
        {{ $t("communication_log.col_concerns") }}:
        <b>{{ communicationLogDetail.concerns.toString() }}</b>
      </div>
      <div class="md-layout-item md-size-100 my-2">
        {{ $t("communication_log.col_communication_detail") }}:
        <b>{{ communicationLogDetail.communication_detail }}</b>
      </div>
      <div class="md-layout-item md-size-100 my-2">
        {{ $t("communication_log.col_responses_parent") }}:
        <b>{{ communicationLogDetail.response_from_parent }}</b>
      </div>
    </div>
    <div class="flex justify-end">
      <md-button class="md-raised" @click="hideModal">
        {{ $t("common.close") }}</md-button
      >
    </div>
  </div>
</template>
<script>
export default {
  props: ["communicationLogDetail", "modalName"],
  methods: {
    hideModal() {
      this.$modal.hide(this.modalName);
    }
  }
};
</script>
<style lang="scss" scoped>
.md-layout-item b {
  margin-left: 1px !important;
}
</style>
